import { type QueryKey, skipToken, useQuery } from '@tanstack/react-query';
import isObject from 'lodash/isObject';

import { type ListSizeSettingPresetsResponse, SizeSettings } from '@air/api';
import { callAirApi } from '@air/utils-api';

export const PRIVATE_SIZE_PRESETS_LIST_KEY = 'PRIVATE_SIZE_PRESETS_LIST';

export type PrivateSizePresetsListKey = [typeof PRIVATE_SIZE_PRESETS_LIST_KEY, UsePrivateSizePresetsListParams];

export const getPrivateSizePresetsListKey = (params: UsePrivateSizePresetsListParams): PrivateSizePresetsListKey => {
  return [PRIVATE_SIZE_PRESETS_LIST_KEY, params];
};

export const isPrivateSizePresetsListKey = (key: QueryKey): key is PrivateSizePresetsListKey => {
  return Array.isArray(key) && key[0] === PRIVATE_SIZE_PRESETS_LIST_KEY && isObject(key[1]);
};

export type UsePrivateSizePresetsListParams = {
  workspaceId: string | undefined;
};

export type UsePrivateSizePresetsListOptions = {
  enabled?: boolean;
  staleTime?: number;
};

export const usePrivateSizePresetsList = (
  params: UsePrivateSizePresetsListParams,
  options?: UsePrivateSizePresetsListOptions,
) => {
  const { workspaceId } = params;

  return useQuery({
    enabled: !!workspaceId && (options?.enabled ?? true),
    queryFn: !workspaceId
      ? skipToken
      : () => callAirApi<ListSizeSettingPresetsResponse>(() => SizeSettings.Presets.list({ workspaceId })),
    queryKey: getPrivateSizePresetsListKey(params),
    staleTime: options?.staleTime,
  });
};
